
<template>
  <!-- 检测报告 -->
  <div class="check_box">
    <div class="head_bg">
      <div class="flex">
        <p class="head_name">{{userInfo.realName}}</p>
      </div>
      <div class="userInfo">
        <ul>
          <li>
            <p class="userkey">手机号码:</p>
            <p class="userValue">{{userInfo.loginPhone?util.checkPhone(userInfo.loginPhone):''}}</p>
          </li>
          <li>
            <p class="userkey">身份证号:</p>
            <p class="userValue">{{userInfo.idCard?util.checkIdCard(userInfo.idCard,6,4):''}}</p>
          </li>
          <li>
            <p class="userkey">查询时间:</p>
            <p class="userValue">{{blackInfo.gmtCreated}}</p>
          </li>
        </ul>
      </div>
      <div class="titleBox">
        <img src="../../assets/img/vip/check/img_title1.png"
             alt="">
        <p class="imgTitle">资·料·风·险·项<span class="titleLine"></span></p>
        <p class="titleInfo">仅用户自主认证的资料范围</p>
      </div>
    </div>
    <div class="item_title">
      <span class="icon1"></span>
      <span class="item_name">身份证有效风险</span>
      <span class="isGray"
            :class="{'isRed':blackInfo.hasIdcard}"><span class="circle"
              v-if="blackInfo.hasIdcard"></span>{{changeStatus(blackInfo.hasIdcard)}}</span>
    </div>

    <!-- 边框套边框模板 -->
    <div class="item">
      <div class="item_con">贷款时的要求，其中规定到贷款需要有效身份证件。若在贷款期间，身份证过期后已经失效或者即将失效，不属于有效身份证件，因此不能贷款。</div>
    </div>
    <div class="item_title">
      <span class="icon2"></span>
      <span class="item_name">年龄不符合要求</span>
      <span class="isGray"
            :class="{'isRed':blackInfo.hasAge}"><span class="circle"
              v-if="blackInfo.hasAge"></span>{{changeStatus(blackInfo.hasAge)}}</span>
    </div>
    <div class="item">
      <div class="item_con perple">通常，机构对借款客户的年龄要求是在22-55周岁之间，能够独立履行和承担贷款责任和义务，具备完全民事行为能力。如果年龄太小经济来源是个问题，而年龄太大，贷出去的钱可能就不能进行资金的回笼了，所以想要申请贷款，年龄一定要符合贷款要求。</div>
    </div>
    <div class="item_title">
      <span class="icon3"></span>
      <span class="item_name">所在地区为高风险地区</span>
      <span class="isGray"
            :class="{'isRed':blackInfo.hasRegion}"><span class="circle"
              v-if="blackInfo.hasRegion"></span>{{changeStatus(blackInfo.hasRegion)}}</span>
    </div>
    <div class="item">
      <div class="item_con">通常，机构会根据以往的还款情况进行数据分析，而有些地区的用户逾期或坏账比例较高，机构会将这些地区列入高风险地区。这些地区的借款人被拒可能性非常高。</div>
    </div>
    <div class="item_title">
      <span class="icon4"></span>
      <span class="item_name">手机号码风险</span>
      <span class="isGray"
            :class="{'isRed':blackInfo.hasPhone}"><span class="circle"
              v-if="blackInfo.hasPhone"></span>{{changeStatus(blackInfo.hasPhone)}}</span>
    </div>
    <div class="item">
      <div class="item_con perple">手机号码是申请贷款第一步，也是最关键的一步，因为无论是电话审核还是后期还款，机构必须通过手机号码才能联系到你。首先，个人手机号必须实名，注册的手机号必须经过本人实名认证，而且手机号使用的时间越长，对申请贷款越有利。其次，如果在审核过程中，你的手机号处于空号、注销、关机或欠费等非正常状态，那你的订单很大可能被拒绝。</div>
    </div>
    <div class="item_title">
      <span class="icon5"></span>
      <span class="item_name">紧急联系人号码风险</span>
      <span class="isGray"
            :class="{'isRed':blackInfo.hasContact}"><span class="circle"
              v-if="blackInfo.hasContact"></span>{{changeStatus(blackInfo.hasContact)}}</span>
    </div>
    <div class="item">
      <div class="item_con">紧急联系人的号码是否处于正常状态，是机构评估你的资料是否真实的指标之一。如果你随便写了个空号、不在网、停机的手机号，审核人员可能会觉得你存在逾期或不还款的高风险行为，将对你的审查更加严格。</div>
    </div>
    <div class="item_title">
      <span class="icon6"></span>
      <span class="item_name">工作情况不符合要求</span>
      <span class="isGray"
            :class="{'isRed':blackInfo.hasWork}"><span class="circle"
              v-if="blackInfo.hasWork"></span>{{changeStatus(blackInfo.hasWork)}}</span>
    </div>
    <div class="item">
      <div class="item_con perple">借款人必须有固定的工作和收入来源，一般来说，机构都要求借款人在当前单位连续工作超过6个月，从而保证借款人稳定的还款能力。</div>
    </div>
    <div class="item_title">
      <span class="icon7"></span>
      <span class="item_name">工作单位电话风险</span>
      <span class="isGray"
            :class="{'isRed':blackInfo.hasWorkPhone}"><span class="circle"
              v-if="blackInfo.hasWorkPhone"></span>{{changeStatus(blackInfo.hasWorkPhone)}}</span>
    </div>
    <div class="item">
      <div class="item_con">众所周知，稳定的工作和可观的收入是还款能力的重要体现，而还款能力又是评估贷款审批结果的重磅指标。如果提供假号码，述说假内容，贷款申请只能暂时搁浅或前功尽弃。</div>
    </div>
    <div class="item_title">
      <span class="icon8"></span>
      <span class="item_name">活体或身份证照片风险</span>
      <span class="isGray"
            :class="{'isRed':blackInfo.hasHuotiAndIdcard}"><span class="circle"
              v-if="blackInfo.hasHuotiAndIdcard"></span>{{changeStatus(blackInfo.hasHuotiAndIdcard)}}</span>
    </div>
    <div class="item">
      <div class="item_con perple">为了防止伪冒他人身份进行欺诈骗贷，一般通过人脸识别、活体验证等方式来核验借款人身份。若存在身份证照片不清晰、身份证照片翻拍、活体认证对比分较低，则机构的审查会更严格。</div>
    </div>
    <div class="titleBox">
      <img src="../../assets/img/vip/check/img_title2.png"
           alt="">
      <p class="imgTitle">个·人·资·质·评·估<span class="titleLine"></span></p>
      <p class="titleInfo">第三方数据综合评估</p>
    </div>
    <div class="dataBox">
      <div class="left_box">
        <p class="dataNum"
           :class="{'f_green':blackInfo.lendSituation==1,'f_blue':blackInfo.lendSituation==2,'f_red':blackInfo.lendSituation==3}">{{blackInfo.passRate}}</p>
        <p>预估通过率</p>
      </div>
      <div class="mid_box"
           :class="{'midBoxB0':blackInfo.lendSituation==1,'midBoxT0':blackInfo.lendSituation==3}"><span class="triangle"
              :class="{'t_green':blackInfo.lendSituation==1,'t_blue':blackInfo.lendSituation==2,'t_red':blackInfo.lendSituation==3}"></span></div>
      <div class="right_box">
        <p class="btn red"
           :class="{'btnAct':blackInfo.lendSituation==3}">难放款</p>
        <p class="btn blue"
           :class="{'btnAct':blackInfo.lendSituation==2}">一般</p>
        <p class="btn green"
           :class="{'btnAct':blackInfo.lendSituation==1}">易放款</p>
      </div>
    </div>
    <div class="titleBox">
      <img src="../../assets/img/vip/check/img_title3.png"
           alt="">
      <p class="imgTitle">报·告·说·明<span class="titleLine"></span></p>
      <!-- <p class="titleInfo">第三方数据综合评估</p> -->
    </div>
    <div class="infoBox">
      1、此报告是由用户本人授权查询。<br>
      2、报告内容以第三方平台数据为依据，报告仅供参考，据此作出的决策均为用户独立的判断，产生的一切结果均由用户独立承担，本平台不承担任何责任。<br>
      3、为了用户的数据安全，本平台不保存任何相关数据，如有需要，请用户自主保存信息。
    </div>
  </div>
</template>

<script>
import PayToast from '@/components/payToast';
export default {
  components: {
    PayToast
  },
  data () {
    return {
      eventKey: 'h5_blacklist_view',
      userInfo: {
        loginPhone: '',
        idCard: '',
        realName: ''
      },
      blackInfo: {},//借贷信息
    }
  },
  mounted () {
    this.util.title('个人信用评估');
    this.getHitInfo();//获取检测信息
  },
  methods: {
    getHitInfo () {
      let _this = this;
      this.$get('/app/h5/blackList/fourHitInfo')
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.userInfo = e.data.byConsumerId;
            _this.blackInfo = e.data.blackInfo;
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    changeStatus (val) {
      if (val) {
        return "命中"
      } else {
        return "未命中"
      }
    },
  }

}
</script>
<style scoped>
.check_box {
  position: relative;
  background: #15032f;
  padding-bottom: 0.37rem;
  width: 100%;
}
/* 检测报告 */
.check_box .head_bg {
  background: url('../../assets/img/vip/check/img_header_bg1.png') no-repeat top
    center;
  background-size: 100% 100%;
  /* width: 100%; */
  height: 3.16rem;
  font-size: 0.28rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  padding-top: 0.44rem;
}
.imgTitle {
  display: inline-block;
  font-size: 0.16rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  left: 0.15rem;
  top: 0.4rem;
  letter-spacing: 3px;
  z-index: 1;
}
.titleInfo {
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  position: absolute;
  left: 0.15rem;
  top: 0.67rem;
}
.titleLine {
  background: #6e1efd;
  height: 0.12rem;
  display: inline-block;
  width: 100%;
  position: absolute;
  left: 0;
  z-index: -11;
  top: 0.13rem;
}
.titleBox {
  padding: 0 0.15rem;
  position: relative;
}
.titleBox img {
  height: 0.71rem;
}
.head_name {
  padding: 0 0.17rem 0rem 0.2rem;
}
.userInfo {
  padding: 0 0.17rem 0rem 0.2rem;
  margin-top: 0.25rem;
  margin-bottom: 0.35rem;
}
.userInfo li {
  display: flex;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(151, 157, 174, 1);
  text-align: left;
  margin-bottom: 0.1rem;
}
.userInfo li:last-child {
  margin-bottom: 0;
}
.userInfo .userkey {
  color: #979dae;
  margin-right: 0.1rem;
}
.userInfo .userValue {
  color: #fff;
}
.icon1,
.icon2,
.icon3,
.icon4,
.icon5,
.icon6,
.icon7,
.icon8 {
  display: inline-block;
  background: url('../../assets/img/vip/check/icon1.png') no-repeat top center;
  background-size: 100% 100%;
  width: 0.2rem;
  height: 0.2rem;
  margin-right: 0.04rem;
}
.icon2 {
  background: url('../../assets/img/vip/check/icon2.png') no-repeat top center;
  background-size: 100% 100%;
}
.icon3 {
  background: url('../../assets/img/vip/check/icon3.png') no-repeat top center;
  background-size: 100% 100%;
}
.icon4 {
  background: url('../../assets/img/vip/check/icon4.png') no-repeat top center;
  background-size: 100% 100%;
}
.icon5 {
  background: url('../../assets/img/vip/check/icon5.png') no-repeat top center;
  background-size: 100% 100%;
}
.icon6 {
  background: url('../../assets/img/vip/check/icon6.png') no-repeat top center;
  background-size: 100% 100%;
}
.icon7 {
  background: url('../../assets/img/vip/check/icon7.png') no-repeat top center;
  background-size: 100% 100%;
}
.icon8 {
  background: url('../../assets/img/vip/check/icon8.png') no-repeat top center;
  background-size: 100% 100%;
}
.item_title {
  font-size: 0.16rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  padding: 0 0.17rem 0 0.15rem;
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 0.22rem;
}
.item_name {
  display: inline-block;
  background: rgba(110, 30, 253, 0.3);
  border-radius: 12px;
  padding: 0 0.1rem;
  text-align: center;
}
.circle {
  display: inline-block;
  width: 0.06rem;
  height: 0.06rem;
  background: #ff492f;
  border-radius: 50%;
  position: absolute;
  top: 0.095rem;
  right: 0.35rem;
}
.isRed,
.isGray {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  position: absolute;
  right: 0.17rem;
}
.isRed {
  color: rgba(255, 73, 47, 1);
}
/* 边框套边框样式 */
.item {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  margin-top: 0.14rem;
  margin-bottom: 0.3rem;
  padding-left: 0.17rem;
  padding-right: 0.17rem;
}
.item_con {
  z-index: 1111;
  border: 1px solid #209e6b;
  background: #15032f;
  color: rgba(255, 255, 255, 0.7);
  padding: 0.1rem 0.09rem 0.1rem 0.14rem;
  line-height: 22px;
}
.perple {
  border: 1px solid #6e1efd;
}
.item_bor_box {
  position: relative;
  color: #ff0000;
  height: 100%;
  width: 100%;
  background: #15032f;
  color: #fff;
  margin: 0 auto;
}
.item_bor {
  padding: 0.1rem 0.14rem;
  position: inherit;
  border: 1px solid #6e1efd;
  background: #15032f;
  left: 0.1rem;
  top: 0.1rem;
  width: 99%;
  height: 100%;
  line-height: 22px;
}
.dataBox {
  position: relative;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  padding: 0 0.15rem;
  margin-top: 0.3rem;
  margin-bottom: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left_box {
  padding-left: 0.1rem;
}
.left_box,
.right_box {
  flex: 0.4;
  text-align: center;
}
.right_box {
  flex: 0.6;
  color: #fff;
}
.right_box .btn {
  width: 0.99rem;
  background: #fc5337;
  border-radius: 2px;
  margin: 0 auto;
  margin-bottom: 0.08rem;
  text-align: center;
  display: block;
}
.right_box .btn:last-child {
  margin-bottom: 0;
}

.right_box .btnAct {
  width: 1.2rem;
}
.right_box .blue {
  background: #12b7f0;
}
.right_box .green {
  background: #35e572;
}
.mid_box {
  text-align: right;
  position: absolute;
  left: 49%;
}
.dataNum {
  font-size: 0.54rem;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: rgba(18, 183, 240, 1);
  line-height: 63px;
}
.f_blue {
  color: #12b7f0;
}
.f_green {
  color: #35e572;
}
.f_red {
  color: #fc5337;
}
.triangle {
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 9px 0 9px 9px;
  border-style: solid;
  border-color: transparent transparent transparent #12b7f0;
  position: relative;
  top: 0.03rem;
}
.midBoxT0 {
  top: 0;
}
.midBoxB0 {
  bottom: 0;
}
.t_green {
  border-color: transparent transparent transparent #35e572;
}
.t_red {
  border-color: transparent transparent transparent #fc5337;
}
.infoBox {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  line-height: 22px;
  padding: 0 0.15rem;
}
</style>